import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from "@ngrx/store";
import { NetworkConnectedState } from "./network-states.enum";

export const networkActions = createActionGroup({
  source: "Network",
  events: {
    Connect: emptyProps(),
    Disconnect: emptyProps(),
    "Socket Connected": props<{ namespace: string,  connected: boolean}>(),
    "Enable Network": props<{ shouldEnableNetwork: boolean }>(),
    "Mark slow": props<{ isSlow }>(),
    "Mark no response": props<{ isNoResponse }>(),
  },
});
